import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/title.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import ShapeIcon from '@static/icon/shape01.png';

interface IProps {
  title: string;
  bigTitle: string;
  tag?: string;
}
interface IState {}

const Title = (props: IProps, state: IState) => {
  const { title, bigTitle, tag } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="title-1610">
      <p className="line-11">
        <img src={ShapeIcon} alt="" />
        <span>{bigTitle}</span>
      </p>
      <p className="line-13">
        <span className="text-13">
          {title}
          {tag && <i>{tag}</i>}
        </span>
        <span className="bar-13">
          <i />
          <b />
        </span>
      </p>
    </section>
  );
};

export default observer(Title);
